import { render, staticRenderFns } from "./BarraNavegacion.vue?vue&type=template&id=5ccc4e74&scoped=true"
import script from "./BarraNavegacion.vue?vue&type=script&lang=js"
export * from "./BarraNavegacion.vue?vue&type=script&lang=js"
import style0 from "./BarraNavegacion.vue?vue&type=style&index=0&id=5ccc4e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccc4e74",
  null
  
)

export default component.exports